import "./DaShell.css";
import PropTypes from "prop-types";
import { Translate } from "../../helpers/TranslatedComponent";
import { T_KEYS } from "../../locales/translationKeys";
import { useAppTheme } from "../../theme/useTheme";
import { useConfig } from "../../contexts/ConfigContext";
import { useT } from "../../hooks/useT";

const DaShell = ({ children }) => {
  const theme = useAppTheme();
  const { config } = useConfig();

  const { t } = useT();

  const privacyLink =
    config?.environment === "development"
      ? t(T_KEYS.DA.SHELL.PRIVACYLINK, T_KEYS.DA.SHELL.PRIVACYLINK)
      : t(T_KEYS.DA.SHELL.PRIVACYProdLINK, T_KEYS.DA.SHELL.PRIVACYProdLINK);
  const termsLink =
    config?.environment === "development"
      ? t(T_KEYS.DA.SHELL.TERMSLINK, T_KEYS.DA.SHELL.TERMSLINK)
      : t(T_KEYS.DA.SHELL.TERMSProdLINK, T_KEYS.DA.SHELL.TERMSProdLINK);

  const privacyLabel = `${t(T_KEYS.DA.SHELL.PRIVACY)} (${t(T_KEYS.DA.SHELL.OPENS_NEW_TAB) || "opens in new tab"})`;
  const termsLabel = `${t(T_KEYS.DA.SHELL.TERMS)} (${t(T_KEYS.DA.SHELL.OPENS_NEW_TAB) || "opens in new tab"})`;
  const brandBackground = theme?.assets?.brandbackground || "/ciam/v1/static/images/ms/brand-background.svg";
  const shellWrapperStyle = { backgroundImage: `url(${brandBackground})` };

  return (
    <div className="da-shell-wrapper" style={shellWrapperStyle}>
      <div className="da-shell-container">
        <a href="#da-main-content" className="da-skip-link">
          <Translate tKey={T_KEYS.DA.SHELL.SKIP_TO_MAIN} />
        </a>

        <header className="da-header">
          {theme?.assets?.logo && <img src={theme.assets.logo} alt={theme?.assets?.logoAlt || "Worldline logo"} />}
        </header>

        <div className="da-shell-bg">{children}</div>

        <footer className="da-footer" aria-label={t(T_KEYS.DA.SHELL.FOOTER_LABEL) || "Site footer"}>
          <span className="da-footer-text">
            <Translate tKey={T_KEYS.DA.SHELL.COPYRIGHT} />
          </span>
          <a
            href={privacyLink}
            className="da-footer-text"
            target="_blank"
            rel="noopener noreferrer"
            aria-label={privacyLabel}
          >
            <Translate tKey={T_KEYS.DA.SHELL.PRIVACY} />
          </a>
          <a
            href={termsLink}
            className="da-footer-text"
            target="_blank"
            rel="noopener noreferrer"
            aria-label={termsLabel}
          >
            <Translate tKey={T_KEYS.DA.SHELL.TERMS} />
          </a>
        </footer>
      </div>
    </div>
  );
};

DaShell.propTypes = {
  children: PropTypes.node,
};

export { DaShell };
